<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="C598"><span class="size_145"><span class="color_0B0E11"><strong><span id="page_6">Acknowledgments</span></strong></span></span></p>
<p class="C583">Big giant kisses and hugs to my husband and best friend, Rob Shugg—he keeps me on track, gives me space and time to create, and supports all my schemes and ideas. For this book in particular, he acted as technical assistant to my longarm quilting machine, studio helper in cutting strips of fabric, and illustrator in creating all the illustrations for this book (on top of taking on extra kid and cooking duties, too—he is a star!).</p>
</div>
<div class="group">
<p class="C583">More kisses and more hugs to my two creative munchkins, Otilija and Orlando—their spontaneous creativity keeps me energized. They offer advice on color and design and are incredibly understanding of my deadlines that involve my spending more time with my sewing machine than with them.</p>
<p class="C583">I also must thank my friend Julie MacMahon for acting as studio helper and design consultant; she is also the sewing star who sewed the <em>Bright Future</em> (<span href="#/xhtml/30_Bright_F#page_88" title="Link target outside of Sample">page 88</span>) quilt top. Thank you to my quilty neighbor Chris Hayes for letting me rummage in her fabric stash, and thank you to Moda for sending me a few fabric samples to play with and use in some of the quilts here and there.</p>
<p class="C583">Thanks to the team at Stash Books for believing in this book and to my agent, Courtney Miller-Callihan, for her continued advice and for helping to make it all happen. Lovely thanks to Mark Heriot for his help with the flat shots of the quilts. Big thanks to Lee Grant, who took the beautiful styled photographs; to Tania, Donna, and Jill, who lent us their homes; and to the beautiful Ella and Otilija, the handsome Orlando, and the patient pets who appear in the book.</p>
<p class="C583">Thank you heaps to Susan Boden for writing such a thoughtful foreword for this book and to all my blog readers, newsletter subscribers, Twitter followers, Facebook fans, Flickr groupies, and fellow bloggers and online crafty pals. You all raise me up and make me a better crafter, better writer, better photographer, and all-around better person. I would not have found crafting as a career if were not for you!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_ACKNOWLE.vue?60c88e58